<template>
    <v-container fluid class="pa-0">
        <v-row
            v-for="(field, index) in schema"
            :key="`row-${index}`"
            no-gutters
            class="py-1"
        >
            <v-col>
                <slot :name="field.name"></slot>
            </v-col>
        </v-row>
        <slot></slot>
    </v-container>
</template>

<script>
export default {
    name: 'VerticalFormLayout',
    props: {
        schema: {
            type: Array,
            required: true
        }
    }
};
</script>
